
import { BaseVue } from "@newview/base-web";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { AuthApi, ModuleinforApi, ProjectInforApi } from "@newview/system-api";
import { customModal } from "@newview/ui";
import RestPassword from "./RestPassword.vue";
import { LoginforApi } from "@newview/basicdata-api";
import { OAuthApi } from "@newview/netsysconfig-api";
import Verify from "./verifition/Verify.vue";
import axios from "axios";
import { ShareroadtoinstitutionApi } from '@newview/basic-api'
@Component({
    name: "Login",
    components: {
        customModal,
        RestPassword,
        Verify,
    },
})
export default class Login extends BaseVue {
    @Prop({ default: "/MainManage" }) defaultPagePath!: any; //默认跳转路由path
    @Prop({ default: "天津智慧工地项目一" }) projectDataName!: String; //线路名称用于登录判断
    @Prop({ default: true }) isVerify!: boolean; //是否验证码
    @Prop({ default: true }) forgotPwdShow!: boolean; //是否显示忘记密码
    moduleinforApi: ModuleinforApi = new ModuleinforApi();
    authApi: AuthApi = new AuthApi();
    loginforApi: LoginforApi = new LoginforApi();
    oAuthApi: OAuthApi = new OAuthApi()
    shareroadtoinstitutionApi: ShareroadtoinstitutionApi = new ShareroadtoinstitutionApi();
    projectInforApi: ProjectInforApi = new ProjectInforApi();
    isloading = false;
    userName = "";
    passWord: any = "";
    verifyCodeImg: any = ""; //验证码图片
    IsShowPanel = false;
    isRememberPwd = true;
    VerificationCode = "";
    Verification_btn = "获取验证码";
    VerificationNoNext = true;
    vcode = false; //验证码
    verifyCode = "";

    qrcodeUrl=""
    qrcodeTicket=""
    loopTimes = 0;
    timer1:any

    async geturlCode(){
        let result:any = await this.authApi.getWxCodeByProjectKey({projectKey:this.projectDataName})
        if (result.code==200){
            await this.dsTasd()
            this.qrcodeUrl = result.data.qrcodeUrl
            this.qrcodeTicket = result.data.qrcodeTicket
        }
    }

    dsTasd(){
        this.loopTimes = 0
        let _this = this;
        this.timer1 = setInterval(()=>{
            _this.checkLogin()
        },3000)
    }

    async checkLogin(){
        this.loopTimes ++
        if(this.loopTimes > 20){
            clearInterval(this.timer1)
        }
        let data:any = await this.authApi.scanCheckLogin(this.qrcodeTicket)
        if (data.code==200){
            if(!this.isNull(data.data)){
                //请求登录
                let loginData:any = await this.authApi.checkWechatScanLogin(data.data, this.projectDataName)
                if (loginData.code==200){
                    clearInterval(this.timer1)
                    this.loginSuccess(loginData)
                }
                this.loopTimes = 30
            }
        }
    }

    success1() {
        localStorage.setItem("MainMenuDatas", "");
        localStorage.setItem("activeMenu", "");
        localStorage.setItem("activeTab", "")

        // params 返回的二次验证参数, 和登录参数一起回传给登录接口，方便后台进行二次验证
        var param = {
            userName: this.userName,
            userPassword: this.base64encode(this.passWord),
            isMobile: 0,
            projectDataName: this.isNull(this.projectDataName) ? "" : this.projectDataName
        };
        this.authApi.login(param).then((res) => {
            if (res.code == 200) {
                this.isloading = false;
                setTimeout(() => {
                    this.loginSuccess(res);
                }, 200);
            } else {
                this.$Message.warning("登录失败，" + res.msg);
                this.isloading = false;
                this.$emit("isloading",false)

            }
        });
    }

    async login() {
        localStorage.setItem("MainMenuDatas", "");
        localStorage.setItem("activeMenu", "");
        if (this.userName == "") {
            this.$Message.warning("请输入用户名");
            return;
        }
        if (this.passWord == "") {
            this.$Message.warning("请输入密码");
            return;
        }
        this.isloading = true;
        this.saveTicket();
    }
    async saveTicket() {
        if (this.isVerify) {
            (this as any).$refs.verify.show();
        } else {
            this.success1()
        }

    }

    mounted() {
        sessionStorage.setItem("token", "");
        let requestParam: any = this.getRequestParam();
        if (requestParam && requestParam.accessKey && requestParam.accessSecret) {
            this.userName = requestParam.accessKey;
            this.passWord = this.base64decode(requestParam.accessSecret);
            this.login();
        }

    }
    // async getdata() {//获取共享线路信息

    // }   
    async loginSuccess(res) {
        // 调用.net接口 获取登录token

        // axios({
        //   // url: "http://115.29.173.88/SysConfigWebApi/api/v1/OAuth/AppBrandInfor?APSKey=1",      //prod
        //   url: "http://192.168.0.118/SysConfigWebApi/api/v1/OAuth/AppBrandInfor?APSKey=af27c4d7b5395dfc90866f798e426f30",         //test
        //   method: "GET",
        // }).then(function (res) {
        //   sessionStorage.setItem("netToken",res.data.result.token)
        // });
        let result: any = await this.oAuthApi.AppBrandInfor("af27c4d7b5395dfc90866f798e426f30")
        if (result.code == 200) {
            sessionStorage.setItem("netToken", result.result.token)
        }

        this.success("登录成功");
      this.$emit("isloading",false)
        sessionStorage.setItem("token", res.data.token);
        sessionStorage.setItem("localUser", JSON.stringify(res.data.userInfo));
        sessionStorage.setItem("isLow", JSON.stringify(res.data.userInfo.isLow));
        this.$globalData_Plms.localUser = res.data.userInfo;
        let allList: any = res.data.userInfo.projectdataList
        if(allList && allList.length>0){
            this.$globalData_Plms.itemInfo = allList[0]
            this.$globalData_Plms.institutioninfor = allList[0].institutioninforList[0];
            this.$globalData_Plms.roleInfo = allList[0].institutioninforList[0].subsysteminforList[0].RoleInfo;
            let res1: any = await this.shareroadtoinstitutionApi.getRoadInfor(
                this.$globalData_Plms.institutioninfor.id
            )
            if (res1.code == 200) {
                this.$globalData_Plms.roadList = res1.data;
                this.$globalData_Plms.roadInfo = res1.data[0];
            }
            this.$globalData_Plms.subSysteminfor = allList[0].institutioninforList[0].subsysteminforList[0]
            this.$globalData_Plms.localUser = res.data.userInfo;
            sessionStorage.setItem(
                'globalData_Plms',
                JSON.stringify(this.$globalData_Plms)
            )
            // this.$router.push(this.defaultPagePath); // 默认跳转路由
            // await this.getdata()

            this.$globalData_Plms.localUser = res.data.userInfo;
            sessionStorage.setItem(
                "globalData_Plms",
                JSON.stringify(this.$globalData_Plms)
            );
            // 登录成功之后查询项目的文件上传大小
            this.projectInforApi.getEntity(res.data.userInfo.projectId).then(res => {
                if (res.code == 200) {
                    localStorage.setItem("fileMaxFileSize", res.data.fileMaxFileSize);
                }
            })
            localStorage.setItem("MainMenuDatas", JSON.stringify(this.loadMenuList(this.$globalData_Plms.subSysteminfor.moduleinforList)));

            let subSysteminfor: any = this.$globalData_Plms.subSysteminfor
            if (!this.isNull(subSysteminfor.RoleInfo.defaultUrl)) {
                this.$router.push(subSysteminfor.RoleInfo.defaultUrl); // 默认跳转路由
            } else {
                this.$router.push(this.defaultPagePath); // 默认跳转路由
            }

            //记录登录日志
            this.loginforApi.save({ content: res.data.userInfo.userTrueName, actionUrl: 'auth/login', logType: 1, createId: res.data.userInfo.id });
        }else{
            this.$router.push(this.defaultPagePath); // 默认跳转路由
        }

    }
    // async getdata() {
    //   //获取共享线路信息
    //   if (this.$globalData_Plms.institutioninfor) {
    //     let institutioninId = this.$globalData_Plms.institutioninfor.id;
    //     let data: any = await this.shareroadtoinstitutionApi.getRoadInfor(
    //       institutioninId
    //     );
    //     if (data.code == 200) {
    //       this.$globalData_Plms.roadInfo = data.data[0];
    //     }
    //   }
    // }
    created() {
        // 监听键盘回车事件
        document.onkeydown = (e) => {
            if (e.keyCode === 13) {
                this.login();
            }
        };
      document.addEventListener('keydown', this.handleKeyDown);
    }
  beforeDestroy() {
      document.removeEventListener('keydown', this.handleKeyDown);
        document.onkeydown = (e) => {
            return;
        };
    }
  handleKeyDown(event){
    if (event.key === 'Backspace' && /360 Chrome/.test(navigator.userAgent)) {
      // 阻止事件默认行为
      event.preventDefault();
    }
  }
    // 企业注册
    enterRegister() {
        let routeData = this.$router.resolve({
            name: "EnterpriseRegister",
        });
        window.open(routeData.href, "_blank");
    }

    loadMenuList(datas) {
        const treeDatas: any = this.Baselinq.from(datas)
            .where((x) => x['pid'] == 0)
            .orderBy((p) => p['orderNo'])
            .toArray()
        for (let data of treeDatas) {
            data.children = this.loadMenuChild(data.id, datas)
        }
        return treeDatas
    }
    loadMenuChild(pid, datas) {
        const childDatas: any = this.Baselinq.from(datas)
            .where((x) => x['pid'] == pid)
            .orderBy((p) => p['orderNo'])
            .toArray()
        if (childDatas.length > 0) {
            for (let data of childDatas) {
                data.children = this.loadMenuChild(data.id, datas)
            }
        }
        return childDatas
    }

    getRequestParam() {
        let href = window.location.href
        let paramString = href.split("?")[1]
        if (!paramString) {
            return false
        }
        let returnData = {}
        paramString.split("&").forEach(element => {
            let data = element.split("=")
            returnData[data[0]] = data[1]
        });
        return returnData
    }

}
